import { render, staticRenderFns } from "./YoungStock.vue?vue&type=template&id=6554d432&"
import script from "./YoungStock.vue?vue&type=script&lang=js&"
export * from "./YoungStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports